var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import TextField from "../../Form/TextField";
import CheckboxField from "../../Form/CheckboxField";
export const SSE_FORM_SYSTEM_REQUIRED_QUESTION_GET_CRITERIA = (formState) => {
    return formState;
};
export const SSE_FORM_SYSTEM_REQUIRED_QUESTION_GET_FORM_STATE = (formField) => __awaiter(void 0, void 0, void 0, function* () {
    return formField;
});
const SSEFormSystemRequiredQuestionForm = ({ makeName, }) => {
    return (_jsxs(_Fragment, { children: [_jsx(TextField, { maxLength: 60, name: makeName("fieldLabel"), label: "Question Label" }), _jsx(CheckboxField, { label: "Required", disabled: true, name: makeName("required"), title: "This is a system default field and cannot be changed" })] }));
};
export const SystemRequiredFormComponent = {
    form: SSEFormSystemRequiredQuestionForm,
    getCriteria: SSE_FORM_SYSTEM_REQUIRED_QUESTION_GET_CRITERIA,
    getFormState: SSE_FORM_SYSTEM_REQUIRED_QUESTION_GET_FORM_STATE,
};
